import { Component, OnInit } from "@angular/core";
import { BACKOFFICEMAIN_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "app/ui/app.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { UserManager } from "../../../business/managers/user.manager";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";

@Component({
    selector: BACKOFFICEMAIN_SELECTOR,
    templateUrl: "./backofficemain.component.html"
})
export class BackofficeMainComponent extends BaseComponent implements OnInit {

    constructor(protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected userManager: UserManager,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    ngOnInit(): void {
        this.userManager.updateLoggedUser();
    }

}
